var map = {
	"./attic.svg": "7194",
	"./baby-room.svg": "dd75",
	"./basement.svg": "1e78",
	"./bath-room.svg": "5fc0",
	"./bedroom.svg": "925e",
	"./child-room.svg": "1e77",
	"./dining-room.svg": "0add",
	"./garage.svg": "c07a",
	"./kitchen.svg": "9197",
	"./laundry-room.svg": "4988",
	"./living-room.svg": "d3aa",
	"./master-bedroom.svg": "8c77",
	"./office.svg": "d97b",
	"./playroom.svg": "950e",
	"./storage-room.svg": "d8aa",
	"./toilet.svg": "7e88",
	"./veranda.svg": "ff93",
	"./wardrobe.svg": "5480"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "58c4";